import {
    defaultIdAttribute,
    defaultMergeStrategy,
    defaultProcessStrategy,
} from '/b2b/common/helpers/Normalizr';

import Vendor from './vendor/IabVendor.schema';
import { schema } from 'normalizr';

export const entityName = 'iabTcfGvl';
export const idAttribute = 'vendorListVersion';

export const mergeStrategy = defaultMergeStrategy(idAttribute);
export const processStrategy = defaultProcessStrategy(idAttribute);

export const IabGvl = new schema.Entity(entityName, undefined, {
    idAttribute: defaultIdAttribute(idAttribute),
    mergeStrategy,
    processStrategy,
});

IabGvl.define({
    vendors: [Vendor],
});

const IabV2 = new schema.Object({
    vendors: new schema.Values(Vendor),
});

export const ConsentConfigIabTcfConfiguration = new schema.Object({
    v2: IabV2,
    vendors: [Vendor],
});

export const ConsentConfigIabConfiguration = new schema.Object({
    tcf: ConsentConfigIabTcfConfiguration,
});
